// noinspection DuplicatedCode

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Button from "@material-tailwind/react/Button";
import Modal from "@material-tailwind/react/Modal";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import { useMutation } from "@tanstack/react-query";
import {
  fetchPost,
  fetchPostSilance,
  fetchGet,
  fetchPostMultipartSeaweed,
} from "../../../fetchers";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { toast } from "react-toastify";

import DatePicker from "react-datepicker";
import { Card } from "@material-tailwind/react";

import "react-datepicker/dist/react-datepicker.css";

// import { alertService } from "../../../../services/AlertService";

// import Loading from "../../../../components/loading/Loading";
import TableMemo from "../../../components/tablecard/TableMemo";
import { TextEditor } from "./TextEditor";

import {
  GetKaryawanMinV2,
  getMinKaryawan,
  karyawanSelector,
} from "../../hrd/karyawan/karyawanSlice";
import {
  //   getIzinTransaksi,
  //   insertIzinTransaksi,
  izinTransaksiSelector,
  updateIzinTransaksi,
} from "../../hrd/transaksi/izin/izinTransaksiSlice";

import { Colors } from "../../../assets/Colors";
import { isRequired, useForm } from "../../../components/isRequired";
import { KaryawanSelectorBuilder } from "../../hrd/karyawan/KaryawanSelector";
import { bagianSelector, getMinBagian } from "../../master/bagian/bagianSlice";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { convertToRaw, EditorState } from "draft-js";
import TableMemoReport from "../../../components/tablecard/TableMemoReport";

const MemoReportPage = ({}) => {
  // let initialState = {};
  const mutation = useMutation((param) => fetchGet("getInternalMemoReport", param));

  const mutationAdd = useMutation((param) =>
    fetchPost("InsertInternalMemo", param)
  );

  const validations = [
    ({ to }) => isRequired(to) || { to: "To wajib diisi" },
    ({ Subject }) => isRequired(Subject) || { Subject: "Subject wajib diisi" },
    ({ Attachment }) =>
      isRequired(Attachment) || { Attachment: "Attachment wajib diisi" },
    ({ description }) =>
      isRequired(description) || { Description: "Description wajib diisi" },
  ];

  let initialState = {
    Bulan: new Date(),
  };

  const {
    changed,
    values,
    isValid,
    errors,
    touched,
    changeHandler,
    editHandler,
    clearHandler,
    submitHandler,
    customHandler,
    changeArrayHandler,
  } = useForm(initialState, validations);
  const [buttonTouched, setButtonTouched] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [start, setStart] = useState(0);
  const [count, setCount] = useState(10);
  const [search, setSearch] = useState("");

  const [showModalAdd, setShowModalAdd] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [ShowAll, setShowAll] = useState(false);

  const mutationFile = useMutation((formData) =>
    fetchPostMultipartSeaweed(formData)
  );
  useEffect(() => {
    const formData = {
      start: start,
      count: count,
      search: "",
      Bulan: (new Date().getMonth() + 1).toString(),
      Tahun: new Date().getFullYear().toString(),
    };
    mutation.mutate(formData);
    // noteRef.current.summernote({
    //   callbacks: {
    //     onChange: function (contents, $editable) {
    //       console.log("onChange:", contents, $editable);
    //     },
    //   },
    // });
    // noteRef.current?.animate(animationFrames, animationTiming);
  }, []);

  function handleSearch(searchValue) {
    let params = {
      start: 0,
      count: 10,
      search: searchValue,
    };
    mutation.mutate(params);
    setStart(0);
    setCount(10);
    setSearch(searchValue);
    // setSearchFetch(true);
  }

  function ClickAdd() {
    setShowModalAdd(true);
    clearHandler();
    setButtonTouched(false);
    dispatch(getMinBagian({ search: "" }));
    dispatch(GetKaryawanMinV2({ search: "" }));
  }

  useEffect(() => {
    if (showModalEdit && !showModalAdd) {
      setShowModalAdd(showModalEdit);
      console.log(currentData);
    }
  }, [showModalEdit]);
  //   onChangeNote = (content) => {
  //     console.log("onChange", content);
  //   };

  function handleCurrentData(values) {
    setCurrentData(values);
  }

  function handleShowAll(e) {
    var isCheck = e.target.checked;
    setShowAll(isCheck);
  }

  function filterApi() {
    const formData = {
      start: start,
      count: count,
      search: search,
      Bulan: isNaN((new Date(values.Bulan).getMonth() + 1).toString())
        ? (new Date().getMonth() + 1).toString()
        : (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: isNaN(new Date(values.Bulan).getFullYear().toString())
        ? new Date().getFullYear().toString()
        : new Date(values.Bulan).getFullYear().toString(),
      ShowAll: ShowAll,
    };
    mutation.mutate(formData);
  }

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <Card>
          <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
            <div className={"w-1/4"}>
              <HrdInputGenerator
                type={"bulan"}
                name={"Bulan"}
                title={"Bulan"}
                value={values}
                required={true}
                onChange={customHandler}
                touched={touched}
                errors={errors}
                size={"full"}
              />
            </div>
            {/* <div className={"w-1/4"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Show All
              </label>

              <input type="checkbox" onChange={handleShowAll}></input>
            </div> */}
            <div className={"w-1/4"}>
              <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                Buka data
              </label>

              <button
                type="button"
                onClick={filterApi}
                className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
              >
                Buka
              </button>
            </div>
          </div>

          <div className="h-auto">
            <div className="container mx-auto max-w-full">
              <div className="grid grid-cols-1 px-4">
                <TableMemoReport
                  usingMutation={true}
                  mutation={mutation}
                  primaryID="ID"
                  transaksi={true}
                  tableData={mutation.data}
                  handleSearch={handleSearch}
                  searchPlaceholder="Memo"
                  currentData={handleCurrentData}
                  isReport={true}
                />
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

export default MemoReportPage;
